<template>
    <div class="register-banner">
        <div class="register-banner__content">
            <div class="register-banner__title">Войти в Хёндэ Аукционы</div>

            <div class="register-banner__subtitle">
                Если у вас уже есть аккаунт, то используйте логин и пароль или Hyundai ID для авторизации на портале.
            </div>

            <UISimpleButton
                class="register-banner__button"
                @clicked="goToLoginPage"
            >
                Войти
            </UISimpleButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const router = useRouter();

    function goToLoginPage(): void {
        router.push({ name: 'Login' });
    }
</script>

<style lang="scss" scoped>
    @use './RegisterBanner.scss' as *;
</style>
